import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {MapaCoreModule} from '@mapa/core';


MapaCoreModule.loadEnvironment(environment)
    .then(() => {
        return platformBrowserDynamic()
            .bootstrapModule(AppModule);
    })
    .catch(err => console.error(err));
